"use strict";

import Scrollbar, { ScrollbarPlugin } from "smooth-scrollbar";

export function smoothScrollbarInit(
  options = {},
  selector = "#page-smooth-scroll"
) {
  let root = document.getElementsByTagName("html")[0];
  root.classList.add("page-smooth-scroll");

  const scrollbar = Scrollbar.init(document.querySelector(selector), {
    ...options,
  });

  return scrollbar;
}

class InvertDeltaPlugin extends ScrollbarPlugin {
  static pluginName = "invertDelta";

  static defaultOptions = {
    events: [],
  };

  transformDelta(delta, fromEvent) {
    if (this.shouldInvertDelta(fromEvent)) {
      return {
        x: delta.y,
        y: delta.x,
      };
    }

    return delta;
  }

  shouldInvertDelta(fromEvent) {
    return this.options.events.some((rule) => fromEvent.type.match(rule));
  }
}
